import React, { useEffect, useState } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import decryptData from '../functions/decryptData';
import { useSelector } from 'react-redux';

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation(); // This hook returns the current location
  //console.log(location, "location")

  const [loginUsername,setLoginUsername] = useState("");
  const [loginPassword,setLoginPassword] = useState("");


  useEffect(() => {
    const status = localStorage.getItem('loginStatus')
    if(status){
      try {
        const decryptedStatus = decryptData(status)
        //console.log(decryptedStatus, "decryptedStatus")
        if(decryptedStatus?.status === "admin"){
          login();
          // If already logged in, navigate to the original route or default route
          navigate(sessionStorage.getItem('redirectPath') || '/home'); 
        }
        } catch (error) {
          //console.log(error)
        }
    }
  },[])

  const handleLogin = () => {
    if(loginUsername === "admin" && loginPassword === "Admin"){
        login();
        // After successful login, navigate to the original route or default route
        const redirectPath = sessionStorage.getItem('redirectPath') || '/home';
        sessionStorage.removeItem('redirectPath'); // Clear sessionStorage after redirection
        navigate(redirectPath);
    }
    else{
        alert("Invalid Credentials")
    }
  };

  // Store the path user tried to access before login
  useEffect(() => {
    // If there was a location before being redirected to login, set it to redirect after login
    if (location.state?.from) {
      setRedirectPath(location.state.from);
    }
  }, [location]);

  return (
    <div className="bg-white rounded-2xl shadow-2xl flex flex-col w-full  items-center max-w-4xl transition duration-1000 ease-out mt-48">
             <h2 className='p-3 text-3xl font-bold text-pink-400'>Admin</h2>
             <div className="inline-block border-[1px] justify-center w-20 border-blue-400 border-solid"></div>
             <h3 className='text-xl font-semibold text-blue-400 pt-2'>Log In!</h3>
             {/* Inputs */}
             <div className='flex flex-col items-center justify-center'>
              <input type='text' name='username' onChange={(e) => setLoginUsername(e.target.value)} className='rounded-2xl px-2 py-1 w-4/5 md:w-full border-[1px] border-blue-400 m-1 focus:shadow-md focus:border-pink-400 focus:outline-none focus:ring-0' placeholder='Username'></input>
              <input type="password" name='password' onChange={(e) => setLoginPassword(e.target.value)} className='rounded-2xl px-2 py-1 w-4/5 md:w-full border-[1px] border-blue-400 m-1 focus:shadow-md focus:border-pink-400 focus:outline-none focus:ring-0' placeholder='Password'></input>
              <button onClick={() => handleLogin()} className='rounded-2xl m-2 text-white bg-blue-400 w-2/5 px-4 py-2 shadow-md hover:text-blue-400 hover:bg-white transition duration-200 ease-in'>
                Log In
              </button>
             </div>
             <div className="inline-block border-[1px] justify-center w-20 border-blue-400 border-solid"></div>
             {/* <p className='text-blue-400 mt-4 text-sm'>Don't have an account?</p>
             <p className='text-blue-400 mb-4 text-sm font-medium cursor-pointer' onClick={() => setIsLogin(false)}>Create a New Account?</p> */}
    </div>
  );
};

export default Login;
